import { Input } from "antd"

const ConfigInput = () => {


    return (
        <div className="config-cell table-cell">
            <Input />
        </div>
    )
}

export default ConfigInput